/*                                                */
/*                                                  */

window.o_global = window.o_global || {};
window.o_util = window.o_util || {};
window.o_global.pali = window.o_global.pali || {};
